import React from 'react'
import PropTypes from 'prop-types'

const classNames = require('classnames')

const GlgModal = ({ children, onOutsideClick = () => {}, contentClassName = '' }) => {
  return (
    <div className="glg-modal-overlay" onClick={onOutsideClick}>
      <div
        className={classNames('glg-modal-content', contentClassName)}
        onClick={(e) => e.stopPropagation()}>
        {children}
      </div>
    </div>
  )
}


GlgModal.propTypes = {
  children: PropTypes.node.isRequired,
  onOutsideClick: PropTypes.func,
  contentClassName: PropTypes.string,
}
export default GlgModal
